import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { PlusIcon, ProjectNameIcon, StatusCheckIcon, EyeIcon } from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { GetAllITQuery } from 'shared/services/it_service/ITService';
import moment from 'moment';
import { routeConstant } from 'shared/routes/RouteConstant';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import ExcelExport from 'shared/components/common/ExcelExport/ExcelExport';
import PoSearchBar from 'shared/components/common/searchbar/PoSearchBar';
import Select from 'react-select';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';

const IGNORED_KEYS = new Set(['_id', '__v', 'createdAt', 'updatedAt', 'created_at', 'updated_at', 'po']);

const deepSearchSingleWord = (obj, word) => {
    if (typeof obj === 'string' || typeof obj === 'number') {
        return obj.toString().toLowerCase().includes(word);
    }

    if (Array.isArray(obj)) {
        return obj.some(item => deepSearchSingleWord(item, word));
    }

    if (typeof obj === 'object' && obj !== null) {
        return Object.entries(obj).some(([key, value]) => {
            if (IGNORED_KEYS.has(key)) {
                return false;
            }
            return deepSearchSingleWord(value, word);
        });
    }

    return false;
};

const deepSearch = (obj, searchTerm) => {
    if (!searchTerm) return true;
    
    // Parse search terms supporting quoted phrases
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const words = [];
    let match;
    while ((match = regex.exec(searchTerm)) !== null) {
        const token = match[1] || match[2] || match[3];
        if (token) {
            words.push(token.toLowerCase());
        }
    }

    if (words.length === 0) return true;
    return words.every(word => deepSearchSingleWord(obj, word));
};

export default function InternalTransfer() {
    const navigate = useNavigate();
    const { theme: { theme } } = useSelector((state) => state.root);
    const [searchMenu, setsearchMenu] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [wareHouses, setWareHouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);

    const queryObj = {};
    if (selectedWarehouse?.value) queryObj.warehouseId = selectedWarehouse.value;
    const queryString = new URLSearchParams(queryObj).toString();

    const { isLoading, data: itList, isSuccess } = GetAllITQuery(queryString);
    const { data: listWareHouse } = GetAllWarehouse();

    useEffect(() => {
        const options = (listWareHouse || []).map((w) => ({
            label: w?.code,
            value: w?._id,
        }));
        setWareHouses(options);

        if (itList) {
            setSearchResults(itList);
        }
    }, [itList, listWareHouse, isSuccess]);

    const SearchBars = (customSearchTerm) => {
        const term = customSearchTerm !== undefined ? customSearchTerm : searchMenu;
        if (term.length > 0) {
            const filteredData = itList.filter((item) => deepSearch(item, term));
            setSearchResults(filteredData);
        } else {
            setSearchResults(itList);
        }
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Transfer#
                    </div>
                ),
                accessor: 'transfer_number',
                Cell: ({ row }) => <div>{row.original?.order_number}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Date
                    </div>
                ),
                accessor: 'created_at',
                Cell: ({ row }) => <div>{moment(row.original?.created_at).format('DD, MMM YYYY')}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Source
                    </div>
                ),
                accessor: 'source',
                Cell: ({ row }) => <div>{row.original?.fromWarehouse?.code || '-'}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Destination
                    </div>
                ),
                accessor: 'destination',
                Cell: ({ row }) => <div>{row.original?.toWarehouse?.code || '-'}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        View
                    </div>
                ),
                accessor: 'view',
                Cell: ({ row }) => <EyeIcon onClick={() => navigate(routeConstant.admin.internalTransfer.viewit.path, { state: { data: row.original } })} style={{ cursor: 'pointer' }} />
            }
        ],
        [theme, navigate]
    );

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <PoSearchBar setsearchMenu={setsearchMenu} searchMenu={searchMenu} suggestionsSource={itList} SearchBars={SearchBars} />
                <div className={styles.Header}>
                    <Heading heading={'Internal Transfer'} headingStyle={styles.Heading} />
                    <div className="d-flex align-items-center">
                        {/* <Select
                            placeholder="Filter by Warehouse"
                            isClearable
                            options={wareHouses}
                            value={selectedWarehouse}
                            onChange={(item) => setSelectedWarehouse(item)}
                            styles={{ control: (base) => ({ ...base, minWidth: 220, borderRadius: '8px' }) }}
                        /> */}
                        <CustomButton
                            Icon={PlusIcon}
                            submitHandle={() => {
                                if (isRestrictActions(screenEnum.internal_transfer, screenActionEnum.create)) {
                                    navigate(routeConstant.admin.internalTransfer.addit.path);
                                }
                            }}
                            IconStyle={classNames('me-1', styles.IconStyle)}
                            text={'New Transfer'}
                            containerStyle={classNames(styles.AddProduct, 'ms-2')}
                        />
                        {/* <ExcelExport data={itList} fileName={'Internal Transfers'} /> */}
                    </div>
                </div>
                <GenericTable columns={columns} data={searchResults || []} TableWrapperStyle={classNames(styles.Table)} />
            </div>
            {isLoading && <OverlayLoading />}
        </DashboardWrapper>
    );
}
